import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdWhatsAppMessageTemplatesCacheKeys: AllRouteEndpoints[] = [];
export const engagementAppGroupIdWhatsAppMessageTemplates =
  "/engagement/:app_group_id/whats_app/message_templates" as const;
export const engagementAppGroupIdWhatsAppMessageTemplateId =
  "/engagement/:app_group_id/whats_app/message_template/:id";
